<div style=" text-align: center; padding: 10% 10px;" *ngIf="app">

    <div>
        <img [src]="'/apps/'+app.id+'/splash.png'" width="200" align="center">

    </div>
    <!--<div>
        <fa-icon icon="paper-plane" class="fa-5x" style="color: #0080C6;"></fa-icon>
    </div>-->

    <div class="confirm_msg">
        Thank you for signing up!

        <div style="font-size: large; margin-top: 15px;">
            Please verify your email before logging in to your ThinkShops account.
        </div>
    </div>

    <div class="frame">
        <div>
            We've sent an email to
            <div style="font-weight: 300; margin-top: 5px;">{{email}}</div>
            <br><br>

            Please check your email and complete the verification.
        </div>
        <br>
        <div style="font-weight: 300; font-size: smaller;">If you don't see it, you may need to check your spam folder.
        </div>

    </div>

    <div style="margin-top: 2em;"><a style="color:#1CA0DA;" [href]="'/?app='+app.id">Go to login page</a></div>



</div>